function sum(args: number[]): number {
  return args.reduce((akk, s) => akk + s, 0);
}

export function getStackedBarChartData(
  values: number[],
  chartWidth: number,
): { percentage: number; width: number; x: number; value: number }[] {
  const total = sum(values);

  const percentages = values.map((num) => num / total);
  const widths = percentages.map((percentage) => percentage * chartWidth);
  const xs = widths.map((w, index) => sum(widths.slice(0, index)));

  return percentages.map((percentage, index) => ({
    percentage,
    value: values[index],
    width: widths[index],
    x: xs[index],
  }));
}
